export const isRtl = (): boolean =>
  typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
